import React, { useEffect } from 'react';
import { Typography, Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../context/SessionContext';

const Logout: React.FC = () => {
  const navigate = useNavigate();
    const { logoutUser } = useSession();

  const handleLogout = async () => {
    logoutUser();
  
    setTimeout(async () => {
      navigate('/login');
    }, 5000); // 2000ms (2 seconds) delay
  };

  useEffect(() => {
    handleLogout()
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '90vh',
        backgroundColor: 'background.default',
        color: 'text.primary',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          maxWidth: 600,
          backgroundColor: 'background.paper',
          padding: 3,
          borderRadius: 2,
          boxShadow: 3,
          textAlign: 'center',
        }}
      >
        <CircularProgress sx={{ mb: 2, color: 'white' }} />
        <Typography variant="h6" gutterBottom>
          Thank you for using the
        </Typography>
        <Typography variant="h4" gutterBottom>
          Black Widow Imaging
        </Typography>
        <Typography variant="h4" gutterBottom>
          Unified Management System
        </Typography>
      </Box>
      <Typography
        variant="body2"
        align="center"
        sx={{
          marginTop: 3,
          color: 'text.secondary',
        }}
      >
        BWI 10 Review &nbsp;&nbsp; Version: 2.5.1
      </Typography>
    </Box>
  );
};

export default Logout;
